<nz-table [nzData]="filteredAttributeValues" [nzShowPagination]="false"
          [nzBordered]="true" [nzLoading]="loading">
    <thead>
    <tr>
        <th class='table-header' colspan="2"></th>
        <th class='table-header' colspan="6">Target</th>
        <th class='table-header' colspan="3" nzRight>Actual</th>
    </tr>
    <tr>
        <th class='table-header'>Brand</th>
        <th class='table-header'>Sub Class</th>
        <th class='table-header' [nzAlign]="'center'">Total Value</th>
        <th class='table-header' [nzAlign]="'center'">Fashion %</th>
        <th class='table-header' [nzAlign]="'center'">Fashion Value</th>
        <th class='table-header' [nzAlign]="'center'">Core %</th>
        <th class='table-header' [nzAlign]="'center'">Core Value</th>
        <th class='table-header' [nzAlign]="'center'">GP %</th>
        <th class='table-header' [nzAlign]="'center'">Total Value</th>
        <th class='table-header' [nzAlign]="'center'">% of Target</th>
        <th class='table-header' [nzAlign]="'center'">Variance to<br />Target Value</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngIf="filteredAttributeValues?.length > 0">
        <tr>
            <td [nzAlign]="'center'" class="custom-footer">Total</td>
            <td [nzAlign]="'center'" class="custom-footer"></td>
            <td [nzAlign]="'center'" class="custom-footer" *ngFor="let column of totalColumns">
                <ng-container [ngSwitch]="column.type">
                    <ng-container *ngSwitchCase="'decimal'">
                        {{ calculateTotal(column.name) | thousandSeparator }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentage'">
                        {{ calculateTotal(column.name) | percentValue }}
                    </ng-container>
                </ng-container>
            </td>
            <td [nzAlign]="'center'" class="custom-footer"> {{ calculateGrossPriceAverage() | percentValue }}</td>
            <td [nzAlign]="'center'" class="custom-footer"> {{ 0 | percentValue }}</td>
            <td [nzAlign]="'center'" class="custom-footer"> {{ 0 | percentValue }}</td>
            <td [nzAlign]="'center'" class="custom-footer">{{ 0| thousandSeparator }}</td>
        </tr>
        <ng-container *ngFor="let attributeValueData of filteredAttributeValues">
            <tr *ngFor="let budget of attributeValueData.budgets">
                <td class="brand-name-cell">{{ attributeValueData.attributeValue }}</td>
                <td class="brand-name-cell">
                    {{ getShortId(budget.productLevelName) }}
                </td>
                <td [nzAlign]="'center'" class="editable-cell">
                    <input
                        type="text"
                        class="ant-input-borderless input"
                        [ngModel]="transformNumberToBeThousandSeparated(budget.totalBudget)"
                        (ngModelChange)="budget.totalBudget = transformNumberToRemoveThousandSeparator($event)"
                        (blur)="updateBudgetCell(attributeValueData, budget, 'totalBudget', budget.totalBudget)"
                        (keyup.enter)="updateBudgetCell(attributeValueData, budget, 'totalBudget', budget.totalBudget)"
                        (focus)="$any($event.target).select()"
                    />
                </td>
                <td [nzAlign]="'center'" class="editable-cell">
                    <input
                        type="text"
                        class="ant-input-borderless input percentage-input"
                        [ngModel]="transformNumberToPercentage(budget.fashionPercentage)"
                        (ngModelChange)="budget.fashionPercentage = transformPercentageToNumber($event)"
                        (blur)="updateBudgetCell(attributeValueData, budget, 'fashionPercentage', budget.fashionPercentage)"
                        (keyup.enter)="updateBudgetCell(attributeValueData, budget, 'fashionPercentage', budget.fashionPercentage)"
                        (focus)="$any($event.target).select()"
                    />
                </td>
                <td [nzAlign]="'center'" class="uneditable-cell">
                    {{ getColumnValue('fashion', budget) | thousandSeparator }}
                </td>
                <td [nzAlign]="'center'" class="editable-cell">
                    <input
                        type="text"
                        class="ant-input-borderless input percentage-input"
                        [ngModel]="transformNumberToPercentage(budget.corePercentage)"
                        (ngModelChange)="budget.corePercentage = transformPercentageToNumber($event)"
                        (blur)="updateBudgetCell(attributeValueData, budget, 'corePercentage', budget.corePercentage)"
                        (keyup.enter)="updateBudgetCell(attributeValueData, budget, 'corePercentage', budget.corePercentage)"
                        (focus)="$any($event.target).select()"
                    />
                </td>
                <td [nzAlign]="'center'" class="uneditable-cell">
                    {{ getColumnValue('core', budget) | thousandSeparator }}
                </td>
                <td [nzAlign]="'center'" class="editable-cell">
                    <input
                        type="text"
                        class="ant-input-borderless input percentage-input"
                        [ngModel]="transformNumberToPercentage(budget.grossPrice)"
                        (ngModelChange)="validateAndSetGrossPrice(budget, $event)"
                        (blur)="updateBudgetCell(attributeValueData, budget, 'grossPrice', budget.grossPrice)"
                        (keyup.enter)="updateBudgetCell(attributeValueData, budget, 'grossPrice', budget.grossPrice)"
                        (focus)="$any($event.target).select()"
                    />
                </td>
                <td [nzAlign]="'center'" class="uneditable-cell">
                    {{ getColumnValue('actual', budget) | percentValue }}
                </td>
                <td [nzAlign]="'center'" class="uneditable-cell">
                    {{ getColumnValue('actual', budget) | percentValue }}
                </td>
                <td [nzAlign]="'center'" class="uneditable-cell">
                    0
                </td>
            </tr>
        </ng-container>
    </ng-container>
    </tbody>
</nz-table>
